<template>
  <div>
    <v-card class="soft-card mt-4 pa-2" style="margin-top: 8px !important;">
      <div class="sw-tabs">
        <button
            :class="{ active: activeTab === 'portfolio' }"
            @click="activeTab = 'portfolio'"
          >
          Portfolio
        </button>
        <!-- <button
          :class="{ active: activeTab === 'projected' }"
          @click="activeTab = 'projected'"
        >
          Projected Profit
        </button>
        <button
          :class="{ active: activeTab === 'payouts' }"
          @click="activeTab = 'payouts'"
        >
          Payout Schedule
        </button>
        <button
          :class="{ active: activeTab === 'payments' }"
          @click="activeTab = 'payments'"
        >
          Daily Payments
        </button>
        <button
          :class="{ active: activeTab === 'accounts' }"
          @click="activeTab = 'accounts'"
        >
          Account Comparison
        </button>
        <button
          :class="{ active: activeTab === 'statements' }"
          @click="activeTab = 'statements'"
        >
          Statements
        </button>
        <button
          :class="{ active: activeTab === 'exposure' }"
          @click="activeTab = 'exposure'"
        >
          Exposure
        </button> -->
      </div>
    </v-card>

    <SuperSyndicatePortfolio v-if="activeTab === 'portfolio'" :syndication-id="syndicationId" />

    <v-card class="soft-card mt-4" v-if="activeTab !== 'statements' && activeTab !== 'portfolio'" style="margin-top: 16px !important; padding: 14px 0px !important;">
      <v-card-title class="pa-4" style="padding: 0px 10px 14px !important;">
        <v-layout row wrap align-center justify-space-between>
          <div>
            <div class="table-title">{{ activeReport.title }}</div>
            <div class="table-subtitle">{{ activeReport.subtitle }}</div>
          </div>
          <ExportMenu />
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-data-table
        class="report-table"
        :headers="activeReport.headers"
        :items="activeReport.items"
        :search="search"
        :pagination.sync="pagination"
        item-key="rowKey"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <td v-for="header in activeReport.headers" :key="header.value" :class="cellClass(header.value, props.item)">
            <span v-if="header.value === 'status' || header.value === 'payoffPace' || header.value === 'ach' || header.value === 'flag'">
              <StatusChip :status="props.item[header.value]" />
            </span>
            <v-btn v-else-if="header.value === 'action'" small outline color="blue-grey" class="export-btn"><v-icon small left>visibility</v-icon>View</v-btn>
            <span v-else-if="isMoneyKey(header.value)">{{ props.item[header.value] | currency }}</span>
            <span v-else>{{ props.item[header.value] }}</span>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-card class="soft-card mt-4 pa-5" v-if="activeTab === 'statements'" style="margin-top: 16px !important;">
      <v-layout row wrap>
        <v-flex xs12 lg8 class="pa-2">
          <div class="section-heading">Statements and Payout Packages</div>
          <div class="muted body-2 mt-1">The super syndicate can pull consolidated statements, payout packages, and separate account level reporting.</div>
          <v-layout row wrap class="mt-4">
            <v-flex xs12 md6 class="pa-2" v-for="item in statementOptions" :key="item">
              <v-card flat class="panel-muted pa-4"><div class="bold-dark">{{ item }}</div></v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 lg4 class="pa-2">
          <v-card flat class="panel-muted pa-4">
            <div class="bold-dark">Export Options</div>
            <v-btn block dark color="blue-grey darken-4" class="export-btn mt-3">Download Combined Statement</v-btn>
            <v-btn block outline color="blue-grey" class="export-btn">Download Payout Schedule</v-btn>
            <v-btn block outline color="blue-grey" class="export-btn">Download Profit Projection</v-btn>
            <v-btn block outline color="blue-grey" class="export-btn">Download Excel Workbook</v-btn>
            <v-btn block outline color="blue-grey" class="export-btn">Download ZIP Package</v-btn>
            <div class="caption muted mt-4">Exports must include payout, plugged daily payment, and projected profit fields shown in the portal. Hidden lender fields should never appear in exported files.</div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import StatusChip from './StatusChip'
import ExportMenu from './ExportMenu'
import SuperSyndicatePortfolio from './SuperSyndicatePortfolio'

export default {
  components: {
    StatusChip,
    ExportMenu,
    SuperSyndicatePortfolio,
  },
  props: {
    syndicationId: { default: null },
  },
  data() {
    return {
      search: '',
      activeTab: 'portfolio',
      pagination: { rowsPerPage: -1 },
      // NOTE: Account Comparison still uses placeholder data; the live
      // breakdown lives in SuperSyndicateOverview (super_syndicate_breakdown API).
      accountBreakdown: [
        { account: 'JCG Fund I', invested: 520000, expectedReturn: 676000, collected: 361200, outstanding: 314800, actualProfit: 41200, projectedProfit: 156000, payoutDue: 18450, scheduledPayout: 22600, pluggedDaily: 6420, deals: 18, defaults: 1, roi: '13.8%', projectedRoi: '30.0%', status: 'Strong' },
        { account: 'JCG Fund II', invested: 310000, expectedReturn: 406100, collected: 188500, outstanding: 217600, actualProfit: 28500, projectedProfit: 96100, payoutDue: 12275, scheduledPayout: 15400, pluggedDaily: 4310, deals: 11, defaults: 0, roi: '15.1%', projectedRoi: '31.0%', status: 'Strong' },
        { account: 'JCG Growth Pool', invested: 405000, expectedReturn: 530550, collected: 203900, outstanding: 326650, actualProfit: 33900, projectedProfit: 125550, payoutDue: 9650, scheduledPayout: 17100, pluggedDaily: 4890, deals: 15, defaults: 2, roi: '10.6%', projectedRoi: '31.0%', status: 'Watch' },
        { account: 'JCG Renewal Fund', invested: 225000, expectedReturn: 292500, collected: 171400, outstanding: 121100, actualProfit: 26400, projectedProfit: 67500, payoutDue: 14300, scheduledPayout: 18900, pluggedDaily: 2760, deals: 8, defaults: 0, roi: '16.4%', projectedRoi: '30.0%', status: 'Strong' }
      ],
      portfolioRows: [
        { rowKey: 'LWZ10482', account: 'JCG Fund I', merchant: 'Metro Deli Group', deal: 'LWZ 10482', date: 'May 18, 2026', participation: 45000, percent: '18%', factor: '1.30', expectedReturn: 58500, projectedProfit: 13500, actualProfit: 3200, collected: 16200, remaining: 42300, pluggedDaily: 378, expectedDaily: 410, schedule: 'Daily', payoutDue: 369, nextPayout: 'May 31, 2026', payoffPace: 'On Pace', status: 'Performing', lastPayment: 'May 27, 2026', action: 'View' },
        { rowKey: 'LWZ10421', account: 'JCG Fund II', merchant: 'Eastline Logistics', deal: 'LWZ 10421', date: 'Apr 30, 2026', participation: 62500, percent: '25%', factor: '1.30', expectedReturn: 81250, projectedProfit: 18750, actualProfit: 6900, collected: 37900, remaining: 43350, pluggedDaily: 812, expectedDaily: 790, schedule: 'Daily', payoutDue: 794, nextPayout: 'May 31, 2026', payoffPace: 'Ahead', status: 'Performing', lastPayment: 'May 28, 2026', action: 'View' },
        { rowKey: 'LWZ10377', account: 'JCG Growth Pool', merchant: 'Bright Auto Center', deal: 'LWZ 10377', date: 'Apr 12, 2026', participation: 38000, percent: '14%', factor: '1.33', expectedReturn: 50540, projectedProfit: 12540, actualProfit: 1800, collected: 11800, remaining: 38740, pluggedDaily: 252, expectedDaily: 355, schedule: 'Daily', payoutDue: 245, nextPayout: 'Pending return clearance', payoffPace: 'Behind', status: 'Slow Pay', lastPayment: 'May 22, 2026', action: 'View' },
        { rowKey: 'LWZ10296', account: 'JCG Renewal Fund', merchant: 'Sahara Market LLC', deal: 'LWZ 10296', date: 'Mar 19, 2026', participation: 29000, percent: '20%', factor: '1.30', expectedReturn: 37700, projectedProfit: 8700, actualProfit: 5400, collected: 28600, remaining: 9100, pluggedDaily: 285, expectedDaily: 280, schedule: 'Daily', payoutDue: 279, nextPayout: 'May 31, 2026', payoffPace: 'Ahead', status: 'Near Payoff', lastPayment: 'May 28, 2026', action: 'View' },
        { rowKey: 'LWZ10144', account: 'JCG Growth Pool', merchant: 'North Star Plumbing', deal: 'LWZ 10144', date: 'Feb 28, 2026', participation: 55000, percent: '22%', factor: '1.30', expectedReturn: 71500, projectedProfit: 16500, actualProfit: 4700, collected: 29700, remaining: 41800, pluggedDaily: 0, expectedDaily: 495, schedule: 'Daily', payoutDue: 0, nextPayout: 'Paused', payoffPace: 'Behind', status: 'Collections', lastPayment: 'May 14, 2026', action: 'View' }
      ],
      payments: [
        { rowKey: 'p1', date: 'May 28, 2026', account: 'JCG Fund II', merchant: 'Eastline Logistics', deal: 'LWZ 10421', gross: 3250, pluggedDaily: 812, share: 812, fees: 18, net: 794, payoutBatch: 'May 31 Batch', ach: 'Settled', status: 'Ready for Payout' },
        { rowKey: 'p2', date: 'May 28, 2026', account: 'JCG Renewal Fund', merchant: 'Sahara Market LLC', deal: 'LWZ 10296', gross: 1425, pluggedDaily: 285, share: 285, fees: 6, net: 279, payoutBatch: 'May 31 Batch', ach: 'Settled', status: 'Ready for Payout' },
        { rowKey: 'p3', date: 'May 27, 2026', account: 'JCG Fund I', merchant: 'Metro Deli Group', deal: 'LWZ 10482', gross: 2100, pluggedDaily: 378, share: 378, fees: 9, net: 369, payoutBatch: 'May 31 Batch', ach: 'Settled', status: 'Ready for Payout' },
        { rowKey: 'p4', date: 'May 26, 2026', account: 'JCG Growth Pool', merchant: 'Bright Auto Center', deal: 'LWZ 10377', gross: 1800, pluggedDaily: 252, share: 252, fees: 7, net: 245, payoutBatch: 'Held', ach: 'Returned R01', status: 'Hold' }
      ],
      payoutSchedule: [
        { rowKey: 's1', payoutDate: 'May 31, 2026', account: 'JCG Fund I', deals: 12, grossCollected: 48750, syndicateShare: 18450, fees: 410, netPayout: 18040, method: 'ACH Credit', status: 'Scheduled' },
        { rowKey: 's2', payoutDate: 'May 31, 2026', account: 'JCG Fund II', deals: 9, grossCollected: 42100, syndicateShare: 12275, fees: 280, netPayout: 11995, method: 'ACH Credit', status: 'Scheduled' },
        { rowKey: 's3', payoutDate: 'May 31, 2026', account: 'JCG Renewal Fund', deals: 7, grossCollected: 33500, syndicateShare: 14300, fees: 315, netPayout: 13985, method: 'ACH Credit', status: 'Scheduled' },
        { rowKey: 's4', payoutDate: 'Jun 03, 2026', account: 'JCG Growth Pool', deals: 8, grossCollected: 28600, syndicateShare: 9650, fees: 220, netPayout: 9430, method: 'ACH Credit', status: 'Review Hold' }
      ],
      exposureRows: [
        { rowKey: 'e1', merchant: 'North Star Plumbing', industry: 'Home Services', account: 'JCG Growth Pool', exposure: 41800, pluggedDaily: 0, expectedDaily: 495, collectedPercent: '42%', status: 'Collections', flag: 'ACH returns' },
        { rowKey: 'e2', merchant: 'Bright Auto Center', industry: 'Auto Repair', account: 'JCG Growth Pool', exposure: 38740, pluggedDaily: 252, expectedDaily: 355, collectedPercent: '23%', status: 'Slow Pay', flag: 'Below schedule' },
        { rowKey: 'e3', merchant: 'Eastline Logistics', industry: 'Transportation', account: 'JCG Fund II', exposure: 43350, pluggedDaily: 812, expectedDaily: 790, collectedPercent: '47%', status: 'Performing', flag: 'High exposure' }
      ],
      statementOptions: [
        'Combined statement for all accounts', 'Separate PDF per syndicate account', 'Payout schedule by account and batch', 'Plugged daily payment backup report', 'Projected profit and remaining profit report', 'Excel workbook with Summary, Payouts, Payments, Portfolio, and one tab per account', 'CSV export for accounting system', 'Year end summary statement'
      ]
    };
  },
  computed: {
    projectedRows: function () {
      return this.portfolioRows.map(function (row) {
        var copy = Object.assign({}, row);
        copy.projectedRoi = ((row.projectedProfit / row.participation) * 100).toFixed(1) + '%';
        copy.completion = Math.round((row.collected / row.expectedReturn) * 100) + '%';
        copy.remainingProfit = row.projectedProfit - row.actualProfit;
        return copy;
      });
    },
    activeReport: function () {
      var reports = {
        portfolio: { title:'Consolidated Portfolio Report', subtitle:'All assigned syndicate accounts with payment schedule, plugged daily payment, payout, and profit math.', headers:this.headers(['account','merchant','deal','date','participation','percent','factor','expectedReturn','collected','remaining','pluggedDaily','expectedDaily','payoutDue','nextPayout','projectedProfit','actualProfit','payoffPace','status','action']), items:this.portfolioRows },
        projected: { title:'Projected Profit Report', subtitle:'Projected return based on participation amount, factor, RTR, current collections, and remaining balance.', headers:this.headers(['account','merchant','participation','factor','expectedReturn','collected','completion','actualProfit','remainingProfit','projectedProfit','projectedRoi','payoffPace']), items:this.projectedRows },
        payouts: { title:'Payout Schedule', subtitle:'Scheduled syndicate payouts by account, batch, method, fees, and release status.', headers:this.headers(['payoutDate','account','deals','grossCollected','syndicateShare','fees','netPayout','method','status']), items:this.payoutSchedule },
        payments: { title:'Daily Payment and Collection Report', subtitle:'Includes gross payment, plugged daily payment, syndicate share, fees, net payout, and ACH result.', headers:this.headers(['date','account','merchant','deal','gross','pluggedDaily','share','fees','net','payoutBatch','ach','status']), items:this.payments },
        accounts: { title:'Account Comparison Report', subtitle:'Compares profit, payout, daily payment, performance, and risk across child syndicate accounts.', headers:this.headers(['account','invested','expectedReturn','collected','outstanding','actualProfit','projectedProfit','payoutDue','scheduledPayout','pluggedDaily','deals','defaults','roi','status']), items:this.accountBreakdown.map(function (x, i) { return Object.assign({ rowKey: 'a' + i }, x); }) },
        exposure: { title:'Exposure and Payment Pace Report', subtitle:'Risk concentration with plugged daily vs expected daily payment.', headers:this.headers(['merchant','industry','account','exposure','pluggedDaily','expectedDaily','collectedPercent','status','flag']), items:this.exposureRows }
      };
      return reports[this.activeTab] || reports.portfolio;
    },
  },
  methods: {
    headers: function (keys) {
      var labels = { account:'Account', merchant:'Merchant', deal:'Deal', date:'Funded/Date', participation:'Participation', percent:'%', factor:'Factor', expectedReturn:'Expected RTR', collected:'Collected', remaining:'Remaining', pluggedDaily:'Plugged Daily', expectedDaily:'Expected Daily', payoutDue:'Payout Due', nextPayout:'Next Payout', projectedProfit:'Projected Profit', actualProfit:'Actual Profit', payoffPace:'Pace', status:'Status', action:'Action', completion:'Completion', remainingProfit:'Remaining Profit', projectedRoi:'Projected ROI', payoutDate:'Payout Date', deals:'Deals', grossCollected:'Gross Collected', syndicateShare:'Syndicate Share', fees:'Fees', netPayout:'Net Payout', method:'Method', gross:'Gross Payment', share:'Syndicate Share', net:'Net Payout', payoutBatch:'Batch', ach:'ACH', invested:'Invested', outstanding:'Outstanding', scheduledPayout:'Scheduled Payout', defaults:'Defaults', roi:'ROI', industry:'Industry', exposure:'Remaining Exposure', collectedPercent:'Collected', flag:'Risk Flag' };
      return keys.map(function (key) { return { text: labels[key] || key, value: key, sortable: true }; });
    },
    isMoneyKey: function (key) {
      var moneyKeys = ['participation','expectedReturn','collected','remaining','pluggedDaily','expectedDaily','payoutDue','projectedProfit','actualProfit','remainingProfit','grossCollected','syndicateShare','fees','netPayout','gross','share','net','invested','outstanding','scheduledPayout','exposure'];
      return moneyKeys.indexOf(key) > -1;
    },
    cellClass: function (key) {
      if (['merchant','account'].indexOf(key) > -1) return 'bold-dark';
      if (['projectedProfit','pluggedDaily'].indexOf(key) > -1) return 'blue-text-custom';
      if (['actualProfit','net','netPayout'].indexOf(key) > -1) return 'green-text-custom';
      return '';
    },
  }
};
</script>

<style scoped src="./Styles/SuperSyndicate.css"></style>
